import { GetBaseUrl } from "@/utils/ConfigHelper";
import Response from "@/utils/Videomonster/Common/Response";
import { PUBLIC_ERROR_CODE } from "@/utils/Error/Constants";
import { GetPublicErrorCode } from "@/utils/Error/Handler";
import axios from "axios";

//TODO::현재는 목업데이터로 가져오게되어있지만 서버에서 apis/popups 작업되면 변경 필요
/**
 * @param {{
 *  country: 'ko' | 'en' | 'jp'
 *  limit?: number
 *  offset?: number
 *  filter?: 0 | 1 | 2
 * }} data
 * @returns {Promise<Response>}
 * @throws {Error}
 */
const GetPopupsData = async (data = {}) => {
  try {
    const url = `${GetBaseUrl()}/apis/events/popups`;
    const params = {
      country: data.country,
      limit: data.limit,
      offset: data.offset,
      filter: data.filter,
    };
    const config = { params };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
};

export default { GetPopupsData };
